module.exports = __webpack_public_path__ + "img/4.03fe54f4.png";